import crypto from 'crypto';

const mykey = crypto.createCipher('aes-128-cbc', 'pass-speedy');
let mystr = mykey.update(process.env.REACT_APP_SECRET, 'utf8', 'hex');
mystr += mykey.final('hex');

export default {
  secret: mystr,
};
